/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';
import {
  fetchSubmissionTemplates,
  upsertSubmissionTemplate,
  deleteSubmissionTemplate,
} from '../actions/submissionTemplate';
import { SubmissionTemplateState } from '../types/submissionTemplate';

const initialState: SubmissionTemplateState = {
  templates: [],
  isFetching: false,
  isSaving: false,
};

const submissionTemplateSlice = createSlice({
  name: 'submissionTemplate',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchSubmissionTemplates.pending, (state) => {
        state.isFetching = true;
      })
      .addCase(fetchSubmissionTemplates.fulfilled, (state, action) => {
        state.isFetching = false;
        state.templates = action.payload.templates ?? [];
      })
      .addCase(fetchSubmissionTemplates.rejected, (state) => {
        state.isFetching = false;
      })
      .addCase(upsertSubmissionTemplate.pending, (state) => {
        state.isSaving = true;
      })
      .addCase(upsertSubmissionTemplate.fulfilled, (state, action) => {
        state.isSaving = false;
        const saved = action.payload;
        const idx = state.templates.findIndex((t) => t.id === saved.id);
        if (idx >= 0) {
          state.templates[idx] = saved;
        } else {
          state.templates.unshift(saved);
        }
      })
      .addCase(upsertSubmissionTemplate.rejected, (state) => {
        state.isSaving = false;
      })
      .addCase(deleteSubmissionTemplate.fulfilled, (state, action) => {
        state.templates = state.templates.filter(
          (t) => t.id !== action.payload.templateId,
        );
      });
  },
});

export default submissionTemplateSlice.reducer;
